(function () {
  function initSection(section) {
    var track = section.querySelector('.jaye-test__track');
    var arrows = section.querySelectorAll('.jaye-test__arrow');
    if (!track || arrows.length === 0) return;

    function step() {
      var card = track.querySelector('.jaye-test-card');
      if (!card) return 470;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    }

    arrows.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = parseInt(btn.getAttribute('data-direction'), 10) || 1;
        track.scrollBy({ left: dir * step(), behavior: 'smooth' });
      });
    });

    function updateArrows() {
      var max = track.scrollWidth - track.clientWidth - 1;
      arrows.forEach(function (btn) {
        var dir = parseInt(btn.getAttribute('data-direction'), 10) || 1;
        if (dir < 0) {
          btn.disabled = track.scrollLeft <= 1;
        } else {
          btn.disabled = track.scrollLeft >= max;
        }
      });
    }

    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();
  }

  function init() {
    document.querySelectorAll('.jaye-test').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
